var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TooltipIconButton',_vm._g({attrs:{"icon":"mdi-download","tooltipText":"tooltip.download","color":_vm.color,"defaultColor":_vm.defaultColor,"disabled":_vm.disabled}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }